// extracted by mini-css-extract-plugin
export default {"wrap":"zG-z","subtitle":"AG-z","contentWrap":"BG-z","imgWrap":"CG-z","heading":"DG-z","copy":"EG-z"};